import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = "https://newalemny.3almny.app/api";

// Async thunk for fetching app settings
export const fetchAppSettings = createAsyncThunk(
  'appSettings/fetchSettings',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/app_settings`);
      return response.data.result;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'حدث خطأ في جلب الإعدادات'
      );
    }
  }
);

const initialState = {
  settings: null,
  loading: false,
  error: null
};

const appSettingsSlice = createSlice({
  name: 'appSettings',
  initialState,
  reducers: {
    clearSettingsError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAppSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
        state.error = null;
      })
      .addCase(fetchAppSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearSettingsError } = appSettingsSlice.actions;
export default appSettingsSlice.reducer;
